import React, { useContext, useEffect, useState } from 'react';
import { Route, Redirect } from 'react-router-dom';
import { AccountContext } from './AccountContext';
import UserPool from './UserPool';
import { consoleDevLog } from './apiConfig';

const ProtectedRoute = ({ component: Component, ...rest }) => {
  const { isAuthenticated, setIsAuthenticated } = useContext(AccountContext);
  const [loading, setLoading] = useState(true);
  const [sessionValid, setSessionValid] = useState(true);

  useEffect(() => {
    const validateSession = async () => {
      // Check if the stored token is valid
      const user = UserPool.getCurrentUser();
      
      if (user) {
        user.getSession((err, session) => {
          if (err || !session || !session.isValid()) {
            consoleDevLog('Session invalid in ProtectedRoute:', err);
            setSessionValid(false);
            setIsAuthenticated(false);
            
            // Clear tokens from localStorage
            window.localStorage.removeItem('idToken');
            window.localStorage.removeItem('accessToken');
            window.localStorage.removeItem('refreshToken');
          } else {
            consoleDevLog('Session valid in ProtectedRoute');
            setSessionValid(true);
            setIsAuthenticated(true);
          }
          setLoading(false);
        });
      } else {
        consoleDevLog('No user found in ProtectedRoute');
        setSessionValid(false);
        setIsAuthenticated(false);
        setLoading(false);
      }
    };

    validateSession();
  }, [setIsAuthenticated]);

  if (loading) {
    return <div className="loading">Verifying session...</div>;
  }

  return (
    <Route
      {...rest}
      render={(props) =>
        isAuthenticated && sessionValid ? (
          <Component {...props} />
        ) : (
          <Redirect
            to={{
              pathname: '/login',
              state: { from: props.location },
            }}
          />
        )
      }
    />
  );
};

export default ProtectedRoute;
